import { datadogRum } from '@datadog/browser-rum'

const env = process.env.rackEnvironment || 'development'

datadogRum.init({
  applicationId: '442b27ac-26d0-4b4c-bc4d-da3fefe00746',
  clientToken: 'pub8a3801169d78b3a0559d8f2e544e5ead',
  site: 'datadoghq.eu',
  service: 'marketing',
  env,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  trackBfcacheViews: true,
  defaultPrivacyLevel: 'allow',
})

export default (_, inject) => {
  inject('datadogRum', datadogRum)
}
